import { useRef } from 'react';

export const useValueAsRef = <T>(value: T) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};
